import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById('first-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-14" data-mp="gokqv61p7sl3">
      {visible && <motion.div initial={{
      y: 120,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 120,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-15" data-mp="gnj6gaysltqp">
          <a href={CHECKOUT_URL} className="animate-shake mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-cta px-5 py-4 text-base sm:text-lg font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-6px_rgba(23,138,61,0.65)] ring-4 ring-white focus:outline-none focus-visible:ring-cta/40" data-id="element-16" data-mp="14dn9ag45ppgn">
            Get instant access — $27
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-17" data-mp="1reg7b0w72m3p" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}